export const BIZ_TYPE_FORM = {
  title: '测试',
  dialog: 'form',
  fields: [
    {
      name: "业务树",
      field: "bizTypeCode",
      type: "cascade",
      rel: "mdmBizType.bizTypeCode",
      relPath: ["mdmBizType.bizTypeName"],
      rules: [
        "required"
      ]
    },
    {
      name: "业务域",
      field: "bizDomain",
      type: "select",
      rel: "bizDomain.code",
      relPath: ["bizDomain.name"],
    },
    {
      name: "业务类型",
      field: "soBizModel",
      type: "select",
      rel: "bizModel.code",
      relPath: ["bizModel.name"],
    },
    {
      name: "测试",
      field: "test",
      type: "radio",
      dataOptions: [
        { value: 1, label: "a" },
        { value: 2, label: "b" },
      ]
    }
  ]
}

export const resourve_FORM = {
  title: '添加相关资源',
  dialog: 'form',
  fields: [
    {
      name: "关联关系",
      field: "relation",
      type: "select",
      rel: "relation.code",
      relPath: ["relation.name"],
      rules: [
        "required"
      ]
    },
    {
      name: "资源文件",
      field: "resourceId",
      type: "selection",
      config:"RESOURCE_SELECTION",
      rel: "ebkResource.id",
      relPath: ["ebkResource.name"],
      rules: [
        "required"
      ]
    }
  ]
}


export const ebkEBook_FORM = {
  title: '添加相关阅读',
  dialog: 'form',
  fields: [
    {
      name: "关联关系",
      field: "relation",
      type: "select",
      rel: "relation.code",
      relPath: ["relation.name"],
      rules: [
        "required"
      ]
    },
    {
      name: "电子书",
      field: "relationEntityId",
      type: "selection",
      config:"EBK_SELECTION",
      rel: "ebkEBook.id",
      relPath: ["ebkEBook.ebookName"],
      rules: [
        "required"
      ]
    }
  ]
}

export const ebkRESOURCE_MORE_FORM = {
  title: '批量录入资源',
  dialog: 'form',
  action: '/dev-api/ebk/ebkResource/upload',
  fields: [{
    name: "资源名称",
    field: "name",
    type: "input",
    rel: "ebkResource.name",
    width: 8,
  },
    
    {
      name: "电子书码",
      field: "ebc",
      type: "input",
      width: 8
    },
    {
      name: "章节码",
      field: "chpc",
      type: "input",
      width: 8
    },
    {
      name: "资源类型",
      field: "resourceType",
      type: "select",
      rel: "resourceType.code",
      relPath: ["resourceType.name"],
      width: 8,
    },
    {
      name: "标签",
      field: "tags",
      type:"dynamic-tag",
      rel: "ebkResource.tags",
      width: 16,
    },
    {
      name: "特征",
      field: "feature",
      type: "input",
      rel: "ebkResource.feature",
      width: 8,
    },
    {
      name: "用途",
      field: "purpose",
      type: "input",
      rel: "ebkResource.purpose",
      width: 8,
    },
    {
      name: "归属",
      field: "owner",
      type: "input",
      rel: "ebkResource.owner",
      width: 8,
    }
  ]
}


export const NOPASS_FORM = {
  title: '审核意见',
  dialog: 'form',
  fields: [{
    name: "审核意见",
    field: "auditOpinion",
    type: "input",
    width: 24,
  }
  ]
}

export const APPAY_FORM = {
  title: '协助处理',
  dialog: 'form',
  fields: [{
    name: "处理类型",
    field: "applyStatus",
    type: "select",
    rel: "auditStatus.code",
    relPath: ["auditStatus.name"]
  },
  {
  name: "处理说明",
  field: "processExplain",
  type: "input",
  width: 24,
}
  ]
}
export const RELEASE_FORM = {
  title: '发布',
  dialog: 'form',
  fields: [{
    name: "发布版本号",
    field: "publishVersion",
    type: "input",
    rules: [
      "required"
    ]
  },
  {
  name: "发布说明",
  field: "publishExplain",
  type: "textarea",
  rules: [
    "required"
  ]
}
  ]
}

export const DEEDBANK_FORM = {
  title: '回复',
  dialog: 'form',
  fields: [{
    name: "回复内容",
    field: "content",
    type: "textarea",
    width: 24,
  }
  ]
}

export const ABILITYADD_FORM = {
  title: '关联能力分类',
  dialog: 'form',
  fields: [
    {
      name: "能力分类类型",
      field: "abilityCategoryType",
      type: "select",
      rel: "abilityCategoryType.code",
      relPath:["abilityCategoryType.name"]
    },
    {
      name: "能力分类",
      field: "abilityCategoryId",
      type: "selection",
      config:"TATABILITY_SELECTION",
      rel: "kbsAbilityCategory.id",
      width:24,
      relPath: ["kbsAbilityCategory.abilityFullName"],
      rules: [
        "required"
      ]
    }
  ]
}